import { features } from "@/locales/en/features";
import { generic } from "@/locales/en/generic";
import { integrations } from "@/locales/en/integrations";
import { models } from "@/locales/en/models";

export { features, generic, integrations, models };

const enLocale = {
  generic,
  models,
  features,
  integrations,
} as const;

export type MessageSchema = typeof enLocale;

export default enLocale;
